var Vendd = (function (Vendd) {
    'use strict';

    Vendd.LazyHtmlArea = (function (LazyHtmlArea) {

        LazyHtmlArea.Messages = (function (Messages) {

            Messages.GetLazyHtmlArea = function (serviceConfiguration) {
                var data = {
                    serviceConfiguration: serviceConfiguration
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea", data);
            }
            Messages.GetLazyHtmlArea.className = "Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea";

            Messages.LazyHtmlAreaSuccess = function (model, sender) {
                var data = {
                    model: model,
                    sender: sender
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyHtmlArea.Messages.LazyHtmlAreaSuccess", data);
            }
            Messages.LazyHtmlAreaSuccess.className = "Vendd.LazyHtmlArea.Messages.LazyHtmlAreaSuccess";

            Messages.LazyHtmlAreaFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyHtmlArea.Messages.LazyHtmlAreaFailure", data);
            }
            Messages.LazyHtmlAreaFailure.className = "Vendd.LazyHtmlArea.Messages.LazyHtmlAreaFailure";


            return Messages;

        })(LazyHtmlArea.Messages || {});

        return LazyHtmlArea;

    })(Vendd.LazyHtmlArea || {});

    return Vendd;

})(Vendd || {});
